import { UserService, AuthenticationError } from '../services/user.service';
import { TokenService } from '../services/token.service';
import router from '../router/index';

const state = {
  authenticating: false,
  accessToken: TokenService.getToken(),
  AuthenticationErrorCode: 0,
  AuthenticationError: ''
};

const getters = {
  loggedIn: (state) => {
    return state.accessToken;
  },

  AuthenticationErrorCode: (state) => {
    return state.AuthenticationErrorCode;
  },

  AuthenticationError: (state) => {
    return state.AuthenticationError;
  },

  authenticating: (state) => {
    return state.authenticating;
  }
};

const actions = {
  async login ({ commit }, body) {
    commit('initRequest');
    try {
      const token = await UserService.login(body);
      commit('loginSuccess', token);

      const profileData = await UserService.getProfile();
      // Get profile basic info on login
      commit('user/setProfileData', profileData, { root: true });
      // Redirect the user to the page he first tried to visit or to the home view
      router.push('/usuario/trabajos');
      // window.location.reload()
      // router.go(0);
      // router.push(router.history.current.query.redirect || '/');

      return;
    } catch (e) {
      if (e instanceof AuthenticationError) {
        commit('loginError', { errorCode: e.errorCode, errorMessage: e.message });
      }
    }
  },

  async loginEmpresa ({ commit }, body) {
    commit('initRequest');

    try {
      const token = await UserService.loginEmpresa(body);
      commit('loginSuccess', token);
      router.push('/empresas/inicio');

      return true;
    } catch (e) {
      console.log('Error: ', e);
      if (e instanceof AuthenticationError) {
        commit('loginError', { errorCode: e.errorCode, errorMessage: e.message });
      }
    }
  },

  async loginAdmin ({ commit }, body) {
    commit('initRequest');

    try {
      const token = await UserService.loginAdmin(body);
      commit('loginSuccess', token);

      // const profileData = await UserService.getProfile();
      // Get profile basic info on login
      // commit('user/setProfileData', profileData, { root: true });

      // Redirect the user to the page he first tried to visit or to the home view
      router.push('/admin/perfil');
      // router.push(router.history.current.query.redirect || '/');

      return true;
    } catch (e) {
      // console.log('Error: ', e);
      if (e instanceof AuthenticationError) {
        commit('loginError', { errorCode: e.errorCode, errorMessage: e.message });
      }
    }
  },

  logout ({ commit }, role) {
    UserService.logout();
    commit('logoutSuccess');
    let routepush = '/';
    if (role === 'Admin') routepush = '/admin/login';
    router.push(routepush);
  }
};

const mutations = {
  initRequest (state) {
    state.authenticating = true;
    state.AuthenticationError = '';
    state.AuthenticationErrorCode = 0;
  },

  loginSuccess (state, accessToken) {
    state.accessToken = accessToken;
    state.authenticating = false;
  },

  loginError (state, { errorCode, errorMessage }) {
    state.authenticating = false;
    state.AuthenticationErrorCode = errorCode;
    state.AuthenticationError = errorMessage;
  },

  logoutSuccess (state) {
    state.accessToken = '';
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
